const $blogComments = $('.blog-comments');

if ($blogComments.length) {
  const $reply = $('.reply', $blogComments);
  $reply.click((e) => {
    e.preventDefault();

    const hash = 'comment';
    const $comment = $(`[name="${hash}"]`);

    $('html, body').stop().animate({
      scrollTop: $comment.offset().top,
    }, 900, 'swing');
  });
}
